import {Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {getEditPriceSheetColumns, getPrivileges, getProductOptionPages, State} from '../reducers/index';
import {map} from 'rxjs/operators';
import {selectFirstTruthy} from '../util/rx-utils';
import {Page} from '../models/Page';

@Component({
  selector: 'cbs-tab-nav',
  templateUrl: './tab-nav.component.html',
})
export class TabNavComponent implements OnInit {
  pages$: Observable<Page[]>;
  viewDocsPrivilege$: Observable<boolean>;
  priceSummaryColumns$: Observable<any[]>;
  @Input() configRoot = '/product-options';
  @Input() selectedPage: string;

  constructor(private store: Store<State>) {
  }

  ngOnInit() {
    this.viewDocsPrivilege$ = selectFirstTruthy(this.store, getPrivileges).pipe(
      map(privileges => privileges['viewDocsPrivilege']));
    this.pages$ = this.store.select(getProductOptionPages);
    this.priceSummaryColumns$ = this.store.select(getEditPriceSheetColumns);
  }

}
